import { gql } from "@apollo/client";

const EXCHANGE_AND_SAVE_PUBLIC_TOKEN = gql`
mutation ExchangeAndSavePublicToken($args: ExchangeAndSavePublicTokenInput!) {
  exchangeAndSavePublicToken(args: $args) {
    _id
    accessToken
    brokerage
    brokerageLogin
    itemId
    status
    tokenType
    tokenEnvironment
  }
}
`;

const UPDATE_ASSETS_JOB = gql`
mutation Mutation {
  testUpdateAssetsJob
}
`;

const DELETE_PLAID_ACCESS_TOKEN = gql`
mutation DeletePlaidAccessToken($plaidAccessTokenId: ID!) {
  deletePlaidAccessToken(plaidAccessTokenId: $plaidAccessTokenId) {
    _id
    accessToken
    brokerage
    brokerageLogin
    itemId
    status
    tokenType
    tokenEnvironment
  }
}
`;

export { EXCHANGE_AND_SAVE_PUBLIC_TOKEN, UPDATE_ASSETS_JOB, DELETE_PLAID_ACCESS_TOKEN };